import { Card, CardContent, CurrencyWrapper, Text } from "@/components/ui";
import type { LucideIcon } from "lucide-react";

type DemandSummaryCard = {
  format: "count" | "currency";
  icon: LucideIcon;
  label: string;
  value?: number;
};

export function DemandReportSummaryCards({
  summaryCards,
  isLoading,
}: {
  summaryCards: DemandSummaryCard[];
  isLoading: boolean;
}) {
  return (
    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
      {summaryCards.map((card) => {
        const Icon = card.icon;

        return (
          <Card key={card.label} className="border-border/60 shadow-sm">
            <CardContent className="space-y-2 pt-4">
              {isLoading ? (
                <>
                  <div className="flex items-center gap-3">
                    <div className="bg-muted h-10 w-10 animate-pulse rounded-full" />
                    <div className="bg-muted h-4 w-32 animate-pulse rounded" />
                  </div>
                  <div className="bg-muted h-7 w-24 animate-pulse rounded" />
                </>
              ) : (
                <>
                  <div className="flex items-center gap-3">
                    <div className="bg-muted text-foreground flex h-10 w-10 items-center justify-center rounded-full">
                      <Icon className="h-5 w-5" />
                    </div>
                    <Text variant="subHeading">{card.label}</Text>
                  </div>
                  <Text variant="title" className="text-2xl leading-8">
                    {card.value === undefined ? (
                      "—"
                    ) : card.format === "count" ? (
                      card.value.toLocaleString()
                    ) : (
                      <CurrencyWrapper as="span" value={card.value} showCents />
                    )}
                  </Text>
                </>
              )}
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
